/* TENDON redesign - PDP galerie (1 aktivni slide + uzky peek dalsiho media).
   Drzi media-grouping kontrakt assets/media-gallery.js:
   - cte JSON <script class="js-data-variant-media">
   - posloucha 'on:variant:change' na nejblizsim .js-product
   - filtruje pres [data-media-id] + selectedOptions[groupOptionIndex]
   - fallback cteni vyberu z .option-selector (dropdown/listed) */
if (!customElements.get('tdn-r-gallery')) {
  class TdnRGallery extends HTMLElement {
    constructor() {
      super();
      if (window.Shopify && Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this.initialised) return;
      this.initialised = true;

      this.section = this.closest('.js-product');
      this.variantPicker = this.section ? this.section.querySelector('variant-picker') : null;
      this.viewer = this.querySelector('.tdn-r-gallery__track');
      this.nav = this.querySelector('.tdn-r-gallery__nav');
      this.prevBtn = this.querySelector('.tdn-r-gallery__btn[name="prev"]');
      this.nextBtn = this.querySelector('.tdn-r-gallery__btn[name="next"]');
      this.counterCurrent = this.querySelector('.tdn-r-gallery__current');
      this.counterTotal = this.querySelector('.tdn-r-gallery__total');
      this.liveRegion = this.querySelector('.tdn-r-gallery__status');

      if (!this.viewer) return;

      this.mediaGroupingEnabled = this.variantPicker
        && this.hasAttribute('data-media-grouping-enabled')
        && this.getMediaGroupData();

      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      } else {
        this.setVisibleItems();
      }

      this.currentIndex = 0;
      const activeItem = this.viewer.querySelector('.tdn-r-gallery__item.is-active:not([hidden])');
      if (activeItem) {
        const index = this.visibleItems.indexOf(activeItem);
        if (index > 0) {
          this.currentIndex = index;
          requestAnimationFrame(() => this.scrollToIndex(this.currentIndex, false));
        }
      }
      this.updateNav();

      const debounce = window.debounce || ((fn, wait) => {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      });

      this.viewer.addEventListener('scroll', debounce(this.handleScroll.bind(this), 150));
      if (this.nav) this.nav.addEventListener('click', this.handleNavClick.bind(this));
      window.addEventListener('on:debounced-resize', this.updateNav.bind(this));

      if (this.section) {
        this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
      }

      this.setAttribute('loaded', '');
    }

    /** Vzdalenost mezi zacatky sousednich slidu (vc. mezery). */
    itemOffset() {
      if (this.visibleItems.length > 1) {
        return this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
      }
      return this.viewer.clientWidth || 1;
    }

    /** Kolik celych slidu je videt naraz (s peekem vychazi 1). */
    perView() {
      const offset = this.itemOffset();
      if (offset <= 0) return 1;
      return Math.max(1, Math.round(this.viewer.clientWidth / offset));
    }

    maxIndex() {
      return Math.max(0, this.visibleItems.length - this.perView());
    }

    scrollToIndex(index, smooth = true) {
      const item = this.visibleItems[index];
      if (!item) return;
      this.viewer.scrollTo({ left: item.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    handleScroll() {
      const offset = this.itemOffset();
      if (offset <= 0) return;
      const newIndex = Math.min(Math.round(this.viewer.scrollLeft / offset), this.maxIndex());
      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
        if (window.pauseAllMedia) window.pauseAllMedia(this);
        this.updateNav();
        this.announce();
      }
    }

    handleNavClick(evt) {
      const btn = evt.target.closest('.tdn-r-gallery__btn');
      if (!btn) return;
      const delta = btn === this.nextBtn ? 1 : -1;
      const newIndex = Math.min(Math.max(this.currentIndex + delta, 0), this.maxIndex());
      if (newIndex === this.currentIndex) return;
      this.currentIndex = newIndex;
      if (window.pauseAllMedia) window.pauseAllMedia(this);
      this.scrollToIndex(this.currentIndex);
      this.updateNav();
      this.announce();
    }

    updateNav() {
      if (!this.nav) return;
      const total = this.visibleItems.length;
      this.nav.dataset.totalItems = total;
      if (this.counterTotal) this.counterTotal.textContent = total;
      if (this.counterCurrent) {
        this.counterCurrent.textContent = Math.min(this.currentIndex + 1, total);
      }
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex();
    }

    /**
     * Nastavi aktivni medium (napr. featured_media varianty).
     * @param {Element} mediaItem - polozka galerie
     * @param {boolean} [scrollToItem] - odscrollovat na polozku
     */
    setActiveMedia(mediaItem, scrollToItem = true) {
      if (!mediaItem || mediaItem.hidden) return;
      const index = this.visibleItems.indexOf(mediaItem);
      if (index === -1) return;
      if (window.pauseAllMedia) window.pauseAllMedia(this);

      this.viewer.querySelectorAll('.tdn-r-gallery__item.is-active')
        .forEach((el) => el.classList.remove('is-active'));
      mediaItem.classList.add('is-active');

      this.currentIndex = Math.min(index, this.maxIndex());
      if (scrollToItem) this.scrollToIndex(this.currentIndex);
      this.updateNav();
      this.announce();
    }

    /** Pole viditelnych polozek + refresh citace. */
    setVisibleItems() {
      this.viewerItems = this.viewer.querySelectorAll('.tdn-r-gallery__item');
      this.visibleItems = Array.from(this.viewerItems).filter((el) => !el.hidden);
      if (this.nav) this.nav.dataset.totalItems = this.visibleItems.length;
      if (this.counterTotal) this.counterTotal.textContent = this.visibleItems.length;
    }

    /**
     * Reakce na zmenu varianty (event z <variant-picker>).
     * @param {object} evt - event 'on:variant:change'
     */
    onVariantChange(evt) {
      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors(evt));
      }

      if (this.viewerItems) {
        if (evt.detail.variant && evt.detail.variant.featured_media) {
          const mediaId = evt.detail.variant.featured_media.id.toString();
          const mediaItem = Array.from(this.viewerItems)
            .find((el) => el.dataset.mediaId === mediaId);
          if (mediaItem) this.setActiveMedia(mediaItem, true);
        } else if (this.mediaGroupChanged) {
          const firstVisible = this.visibleItems[0];
          if (firstVisible) this.setActiveMedia(firstVisible, true);
        }
      }
    }

    /**
     * Skupina medii dle aktualne vybranych options.
     * @param {object} evt - event 'on:variant:change' (nepovinne)
     * @returns {?string}
     */
    getMediaGroupFromOptionSelectors(evt) {
      if (evt) {
        return evt.detail.selectedOptions[this.getMediaGroupData().groupOptionIndex];
      }
      return this.getSelectedOptions()[this.getMediaGroupData().groupOptionIndex];
    }

    /** JSON mapy media.id -> group (viz .js-data-variant-media). */
    getMediaGroupData() {
      if (typeof this.variantMediaData === 'undefined') {
        const dataEl = this.querySelector('.js-data-variant-media');
        this.variantMediaData = dataEl ? JSON.parse(dataEl.textContent) : false;
      }
      return this.variantMediaData;
    }

    /**
     * Zobrazi jen media prislusna vybrane skupine (barve).
     * Stejna semantika jako media-gallery.js vc. all-groups start/end.
     * @param {?string} groupName - nazev skupiny
     */
    setActiveMediaGroup(groupName) {
      this.mediaGroupChanged = this.currentMediaGroup !== groupName;
      this.currentMediaGroup = groupName;
      if (!this.mediaGroupChanged) {
        if (!this.visibleItems) this.setVisibleItems();
        return;
      }

      const items = this.viewer.querySelectorAll('.tdn-r-gallery__item');

      const resetVisibility = () => {
        items.forEach((mediaItem) => { mediaItem.hidden = false; });
      };

      if (!groupName) {
        resetVisibility();
        this.setVisibleItems();
        this.currentIndex = 0;
        this.updateNav();
        return;
      }

      const mediaGroupData = this.getMediaGroupData();
      let anyVisible = false;

      items.forEach((el) => {
        const mediaItemGroup = mediaGroupData.media[el.dataset.mediaId].group;
        const showThis = mediaItemGroup === groupName || mediaItemGroup === true;
        el.hidden = !showThis;
        if (showThis) anyVisible = true;
      });

      if (anyVisible) {
        // all-groups media na zacatek/konec
        [...items].forEach((el) => {
          if (mediaGroupData.media[el.dataset.mediaId].group === true) {
            if (mediaGroupData.media[el.dataset.mediaId].position === 'start') {
              el.parentElement.prepend(el);
            } else {
              el.parentElement.append(el);
            }
          }
        });

        // skryte polozky na konec (kvuli poradi flexu)
        [...items].filter((el) => el.hidden).forEach((el) => el.parentElement.append(el));
      } else {
        resetVisibility();
      }

      this.setVisibleItems();
      this.currentIndex = 0;
      this.viewer.scrollTo({ left: 0 });
      this.updateNav();
    }

    /** Fallback cteni vybranych hodnot primo z variant-pickeru. */
    getSelectedOptions() {
      const selectedOptions = [];
      this.variantPicker.querySelectorAll('.option-selector').forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          const checked = selector.querySelector('input:checked');
          selectedOptions.push(checked ? checked.value : null);
        }
      });
      return selectedOptions;
    }

    /** Oznami zmenu slidu do live regionu. */
    announce() {
      if (!this.liveRegion || !window.theme || !theme.strings || !theme.strings.imageAvailable) return;
      this.liveRegion.setAttribute('aria-hidden', 'false');
      this.liveRegion.innerHTML = theme.strings.imageAvailable.replace('[index]', this.currentIndex + 1);
      setTimeout(() => {
        this.liveRegion.setAttribute('aria-hidden', 'true');
      }, 2000);
    }
  }

  customElements.define('tdn-r-gallery', TdnRGallery);
}
